export default "__VITE_ASSET__ClQWOpTp__"